"use client";

import { SceneTemplateBrandingForeground } from "@/lib/utils/lomda/types";
import { calcBorderRadius } from "./utils";

export interface LomdaEditorForegroundProps {
    foreground: SceneTemplateBrandingForeground;
    backgroundColor: string;
    children?: React.ReactNode;
}

export default function LomdaEditorForeground({
    foreground,
    backgroundColor,
    children,
}: LomdaEditorForegroundProps) {
    const circleRadius = foreground?.circle ? `9999px / 9999px` : undefined;
    const foregroundStyle = foreground
        ? {
              backgroundColor,
              borderRadius: foreground?.rounded
                  ? calcBorderRadius(
                        foreground.size.width,
                        foreground.size.height
                    )
                  : circleRadius
                  ? circleRadius
                  : "unset",
              width: circleRadius ? "auto" : `${foreground.size.width}%`,
              height: `${foreground.size.height}%`,
              top: `${foreground.location.y}%`,
              right: `${foreground.location.x}%`,
              aspectRatio: circleRadius ? "1/1" : "unset",
          }
        : undefined;
    return (
        <div className="absolute overflow-hidden" style={foregroundStyle}>
            {children}
        </div>
    );
}
